/// <amd-module name="SuiteCommerce.Blog.TaxonomyNavigation.Taxonomy.Collection"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.TaxonomyNavigation.Taxonomy.Collection", ["require", "exports", "SuiteCommerce.Blog.TaxonomyNavigation.Taxonomy.Model", "Backbone"], function (require, exports, TaxonomyNavigation_Taxonomy_Model_1, Backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var TaxonomyNavigationTaxonomyCollection = /** @class */ (function (_super) {
        __extends(TaxonomyNavigationTaxonomyCollection, _super);
        function TaxonomyNavigationTaxonomyCollection() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.model = TaxonomyNavigation_Taxonomy_Model_1.TaxonomyNavigationTaxonomyModel;
            _this.comparator = function (model) {
                return model.name;
            };
            return _this;
        }
        return TaxonomyNavigationTaxonomyCollection;
    }(Backbone_1.Collection));
    exports.TaxonomyNavigationTaxonomyCollection = TaxonomyNavigationTaxonomyCollection;
});
